import { Route, Switch } from 'react-router-dom';
import { lazy } from 'react';
const LoginPage = lazy(() => import('./pages/login'));
const SlotGameLoginPage = lazy(() => import('./pages/slot-game-login'));
const SlotGameConsentPage = lazy(() => import('./pages/slot-game-consent'));
const OrderListPage = lazy(() => import('./pages/order/list'));
const OrderDetailPage = lazy(() => import('./pages/order/order-detail'));
const ProductListPage = lazy(() => import('./pages/product/list'));
const ProductRegisterPage = lazy(() => import('./pages/product/register'));
const ProductUpdatePage = lazy(() => import('./pages/product/update/[id]'));
const InvoiceManagePage = lazy(() => import('./pages/order/invoice/manage'));
const InvoiceRegisterPage = lazy(() => import('./pages/order/invoice/register'));
const InvoiceUploadPage = lazy(() => import('./pages/order/invoice/upload'));
const InvoiceEmptyPage = lazy(() => import('./pages/order/invoice/empty/InvoiceEmptyPage'));
const UserListPage = lazy(() => import('./pages/user/list'));
const UserDetailPage = lazy(() => import('./pages/user/list/[id]'));
const CategoryListPage = lazy(() => import('./pages/category/list'));
const CategoryRegisterPage = lazy(() => import('./pages/category/register'));
const BestListPage = lazy(() => import('./pages/main/best/list'));
const InvoiceListOldPage = lazy(() => import('./pages/order/invoice/listOld'));
const PushListPage = lazy(() => import('./pages/push/list'));
const PushSendPage = lazy(() => import('./pages/push/send'));
const PushUpdatePage = lazy(() => import('./pages/push/update/[id]'));
const CategoryUpdatePage = lazy(() => import('./pages/category/update/[id]'));
const CumaDistributorListPage = lazy(() => import('./pages/distributor/list'));
const CumaDistributorRegisterPage = lazy(() => import('./pages/distributor/register'));
const CumaDistributorUpdatePage = lazy(() => import('./pages/distributor/update/[id]'));
const CumaDeliveryCompanyListPage = lazy(() => import('./pages/delivery/list'));
const CumaDeliveryCompanyRegisterPage = lazy(() => import('./pages/delivery/register'));
const CumaDeliveryCompanyUpdatePage = lazy(() => import('./pages/delivery/update/[id]'));
const CumaDepositListPage = lazy(() => import('./pages/deposit/list'));
const CumaAdminListPage = lazy(() => import('./pages/admin/list'));
const FaqListPage = lazy(() => import('./pages/board/faq/list'));
const FaqRegisterPage = lazy(() => import('./pages/board/faq/register'));
const FAQUpdatePage = lazy(() => import('./pages/board/faq/update/[id]'));
const CumaNoticeRegisterPage = lazy(() => import('./pages/board/notice/register'));
const CumaNoticeUpdatePage = lazy(() => import('./pages/board/notice/update/[id]'));
const CumaNoticeListPage = lazy(() => import('./pages/board/notice/list'));
const CumaReviewRegisterPage = lazy(() => import('./pages/post/review/register'));
const CumaReviewListPage = lazy(() => import('./pages/post/review/list'));
import { ProgressbarProvider } from './context/progressbar';
const SNSListPage = lazy(() => import('./pages/sns/list'));
const AppSideBar = lazy(() => import('./views/layout/AppSideBar'));
const AppTopBar = lazy(() => import('./views/layout/AppTopBar'));
import { SidebarProvider } from './context/sidebar';
const CumaAdminRegisterPage = lazy(() => import('./pages/register/register'));
const CumaAdminDetailPage = lazy(() => import('./pages/admin/detail'));
const CumaLogListPage = lazy(() => import('./pages/log/list'));
const LogSalesPage = lazy(() => import('./pages/log/sales'));
const LogPointPage = lazy(() => import('./pages/log/point'));
const InvoiceLogsPage = lazy(() => import('./pages/order/invoice/invoiceLogsPage'));
const CumaWithdrawErrorLogListPage = lazy(() => import('./pages/log/withdraw-error-list'));
const InvoiceListPage = lazy(() => import('./pages/order/invoice/list'));
const HomeDisplayPage = lazy(() => import('./pages/home'));
const VideoUpdatePage = lazy(() => import('./pages/contents/video/update/[id]'));
const VideoListPage = lazy(() => import('./pages/contents/video/list'));
const VideoRegisterPage = lazy(() => import('./pages/contents/video/register'));
const BannerListPage = lazy(() => import('./pages/contents/banner/list'));
const BannerRegisterPage = lazy(() => import('./pages/contents/banner/register'));
const SettingPage = lazy(() => import('./pages/setting/setting'));
const ShortURLPage = lazy(() => import('./pages/etc/short-url'));
const GiftListPage = lazy(() => import('./pages/order/gift/list/list'));
const GiftDetailPage = lazy(() => import('./pages/order/gift/[id]'));
const InvoiceSettingListPage = lazy(() => import('./pages/setting/invoice/list/InvoiceSettingListPage'));
const InvoiceSettingDetailPage = lazy(() => import('./pages/setting/invoice/detail/InvoiceSettingDetailPage'));
import { Suspense } from 'react';
import MainPage from './pages/main';
const OrderOptionChangePage = lazy(() => import('./pages/order/option-change'));
const PointLogPage = lazy(() => import('./pages/promotion/point/log'));
const PointManagePage = lazy(() => import('./pages/promotion/point'));
const CalculationPage = lazy(() => import('./pages/calculation'));
const ManageGradePage = lazy(() => import('./pages/promotion/manage-grade'));
const ManageGradeDetailPage = lazy(() => import('./pages/promotion/manage-grade/[id]'));
const CouponManagePage = lazy(() => import('./pages/promotion/coupon/management'));
const CouponDisplayPage = lazy(() => import('./pages/promotion/coupon/display'));
const CouponRegisterPage = lazy(() => import('./pages/promotion/coupon/management/register'));
const CouponUpdatePage = lazy(() => import('./pages/promotion/coupon/management/update/[id]'));
const CouponZoneRegisterPage = lazy(() => import('./pages/promotion/coupon/display/register'));
const CouponZoneUpdatePage = lazy(() => import('./pages/promotion/coupon/display/update/[id]'));
const BlackListPage = lazy(() => import('./pages/user/blacklist'));
const StatisticsPage = lazy(() => import(`./pages/statistics/index`));
const ProductFundingListPage = lazy(() => import('./pages/product/funding/list'));
const DashboardPage = lazy(() => import('./pages/dashboard/index'));
const AdminNoticeListPage = lazy(() => import('./pages/board/admin-notice/index'));
const AdminNoticeUpdatePage = lazy(() => import('./pages/board/admin-notice/update/[id]'));
const PurchaseInducementPage = lazy(() => import('./pages/setting/purchase-inducement/index'));
const ProductTagPage = lazy(() => import('./pages/product/tag/index'));
const ReviewManagementPage = lazy(() => import('./pages/review/list'));
const ReviewIntegratedRegisterPage = lazy(() => import('./pages/review/register'));
const CumaReviewPopupPage = lazy(() => import('./pages/post/review/popup'));
const CumaReviewAdminPage = lazy(() => import('./pages/post/review/admin'));

const LiveList = lazy(() => import('./pages/live/list'));
const LiveConsole = lazy(() => import('./pages/live/console/[id]'));
const LiveDetail = lazy(() => import('./pages/live/detail/[id]'));
const LiveBanListDetail = lazy(() => import('./pages/live/ban-list'));
const LiveProductSetting = lazy(() => import('./pages/live/product-setting'));

interface LayoutProps {
    children: React.ReactNode;
}

const DefaultLayout: React.FC<LayoutProps> = ({ children }) => (
    <SidebarProvider>
        <ProgressbarProvider>
            <AppTopBar />
            <AppSideBar />
            {children}
        </ProgressbarProvider>
    </SidebarProvider>
);

const NoSidebarLayout: React.FC<LayoutProps> = ({ children }) => <>{children}</>;

function App(): JSX.Element {
    return (
        <>
            <Suspense fallback={<div>loading..</div>}>
                <Switch>
                    <Route path="/post/review/popup/:type/:id">
                        <NoSidebarLayout>
                            <CumaReviewPopupPage />
                        </NoSidebarLayout>
                    </Route>
                    <Route>
                        <DefaultLayout>
                            <Switch>
                                {/* <Route component={PostListPage} path={['/@:username', '/']} exact /> */}
                                <Route component={LoginPage} path="/login" exact />
                                <Route component={SlotGameLoginPage} path="/sso/authorize" exact />
                                <Route component={SlotGameConsentPage} path="/sso/consent" exact />
                                <Route component={CumaAdminRegisterPage} path="/register" exact />
                                <Route component={DashboardPage} path="/dashboard" exact />
                                <Route component={PushListPage} path="/push/list" exact />
                                <Route component={PushSendPage} path="/push/send" exact />
                                <Route component={PushUpdatePage} path="/push/update/:pushId" />
                                <Route component={OrderListPage} path="/order/list" exact />
                                <Route component={MainPage} path="/" exact />
                                <Route component={OrderDetailPage} path="/order/list/:id" exact />
                                <Route component={InvoiceManagePage} path="/order/invoice/manage" />
                                <Route component={InvoiceRegisterPage} path="/order/invoice/register" />
                                <Route component={InvoiceListPage} path="/order/invoice/list" />
                                <Route component={InvoiceLogsPage} path="/order/invoice/logs" />
                                <Route component={InvoiceListOldPage} path="/order/invoice/list-old" />
                                <Route component={InvoiceUploadPage} path="/order/invoice/upload" />
                                <Route component={InvoiceEmptyPage} path="/order/invoice/empty" exact />
                                <Route component={OrderOptionChangePage} path="/order/change-option" exact />
                                <Route component={UserListPage} path="/user/list/" exact />
                                <Route component={UserDetailPage} path="/user/list/:id" />
                                <Route component={ProductListPage} path="/product/list" exact />
                                <Route component={ProductFundingListPage} path="/product/funding/list" exact />
                                <Route component={ProductRegisterPage} path="/product/register" exact />
                                <Route component={ProductTagPage} path="/product/tag" exact />
                                <Route component={ProductUpdatePage} path="/product/update/:productId" />
                                <Route component={ReviewManagementPage} path="/review/list" exact />
                                <Route component={ReviewIntegratedRegisterPage} path="/review/register" exact />
                                <Route component={ReviewIntegratedRegisterPage} path="/review/register/:id" />
                                <Route component={VideoListPage} path="/contents/video/list" />
                                <Route component={VideoUpdatePage} path="/contents/video/update/:videoId" />
                                <Route component={VideoRegisterPage} path="/contents/video/register" />
                                <Route component={BannerListPage} path="/contents/banner/list" />
                                <Route
                                    component={BannerRegisterPage}
                                    path={['/contents/banner/register', '/contents/banner/update/:bannerId']}
                                />
                                <Route component={HomeDisplayPage} path="/home/display" />
                                <Route component={CategoryListPage} path="/category/list" />
                                <Route component={CategoryRegisterPage} path="/category/register" />
                                <Route component={CategoryUpdatePage} path="/category/update/:categoryId" />
                                <Route component={CumaDistributorListPage} path="/distributor/list" />
                                <Route component={CumaDistributorRegisterPage} path="/distributor/register" />
                                <Route
                                    component={CumaDistributorUpdatePage}
                                    path="/distributor/update/:distributorId"
                                />
                                <Route component={CumaDeliveryCompanyListPage} path="/delivery-company/list" />
                                <Route component={CumaDeliveryCompanyRegisterPage} path="/delivery-company/register" />
                                <Route
                                    component={CumaDeliveryCompanyUpdatePage}
                                    path="/delivery-company/update/:deliveryCompanyId"
                                />
                                <Route component={CumaDepositListPage} path="/deposit/list" />
                                <Route component={CumaAdminListPage} path="/admin/list" />
                                <Route component={CumaAdminDetailPage} path="/admin/:id" />
                                <Route component={BestListPage} path={['/main/best/list', '/main/event/register']} />
                                <Route component={FaqListPage} path="/board/faq/list" />
                                <Route component={FaqRegisterPage} path="/board/faq/register" />
                                <Route component={FAQUpdatePage} path="/board/faq/update/:faqId" />
                                <Route component={CumaNoticeListPage} path="/board/notice/list" />
                                <Route component={CumaNoticeRegisterPage} path="/board/notice/register" />
                                <Route component={CumaNoticeUpdatePage} path="/board/notice/update/:noticeId" />
                                <Route component={CumaReviewListPage} path="/post/review/list" />
                                <Route component={CumaReviewRegisterPage} path="/post/review/register" />
                                <Route component={CumaReviewPopupPage} path="/post/review/popup" />
                                <Route component={CumaReviewAdminPage} path="/post/review/admin" />
                                <Route component={SNSListPage} path="/sns/list" />
                                <Route component={CumaLogListPage} path="/log-list" />
                                <Route component={LogSalesPage} path="/log/sales" />
                                <Route component={LogPointPage} path="/log/point" />
                                <Route component={CumaWithdrawErrorLogListPage} path="/withdraw-error-log-list" />
                                <Route component={SettingPage} path="/setting" exact />
                                <Route component={InvoiceSettingListPage} path="/setting/invoice/list" exact />
                                <Route
                                    component={InvoiceSettingDetailPage}
                                    path={['/setting/invoice/detail/:id', '/setting/invoice/register']}
                                    exact
                                />
                                <Route component={PurchaseInducementPage} path="/purchase-inducement" exact />
                                <Route component={ShortURLPage} path="/etc/short-url" />
                                <Route component={GiftListPage} path="/order/gift/list" />
                                <Route component={GiftDetailPage} path="/order/gift/detail/:giftId" />
                                <Route component={CalculationPage} path="/calculation" exact />
                                <Route component={PointManagePage} path="/promotion/point" exact />
                                <Route component={PointLogPage} path="/promotion/point/logs" exact />
                                <Route component={ManageGradePage} path="/promotion/manage-grade" exact />
                                <Route component={ManageGradeDetailPage} path="/promotion/manage-grade/:id" exact />
                                <Route component={CouponManagePage} path="/promotion/coupon/management" exact />
                                <Route component={CouponDisplayPage} path="/promotion/coupon/display" exact />
                                <Route
                                    component={CouponRegisterPage}
                                    path="/promotion/coupon/management/register"
                                    exact
                                />
                                <Route
                                    component={CouponUpdatePage}
                                    path="/promotion/coupon/management/update/:id"
                                    exact
                                />
                                <Route
                                    component={CouponZoneRegisterPage}
                                    path="/promotion/coupon/display/register"
                                    exact
                                />
                                <Route
                                    component={CouponZoneUpdatePage}
                                    path="/promotion/coupon/display/update/:id"
                                    exact
                                />
                                <Route component={BlackListPage} path="/user/blacklist" exact />
                                <Route component={StatisticsPage} path="/statistics" exact />
                                <Route component={AdminNoticeListPage} path="/board/admin-notice/list" exact />
                                <Route
                                    path={['/board/admin-notice/update/:id', '/board/admin-notice/register']}
                                    component={AdminNoticeUpdatePage}
                                />
                                <Route component={LiveList} path={'/live/list'} />
                                <Route component={LiveConsole} path={'/live/console/:id'} />
                                <Route component={LiveDetail} path={'/live/detail/:id'} />
                                <Route component={LiveBanListDetail} path={'/live/ban-list'} />
                                <Route component={LiveProductSetting} path={'/live/product-setting'} />
                            </Switch>
                        </DefaultLayout>
                    </Route>
                </Switch>
            </Suspense>
        </>
    );
}

export default App;
